var app = angular.module('leonardo');

var PropertyService = function(BaseRestService, RestangularProvider, $q, ConfigThemeService, Upload) {
  var service = new BaseRestService('properties', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('properties', false, function(property) {
      property.addRestangularMethod('setNovice', 'post', 'novice');
      property.addRestangularMethod('unDelete', 'patch', 'undelete');
      property.addRestangularMethod('moveToPortfolio', 'post', 'move-to-portfolio');
      return property;
    });
  });

  service.getAvailableToAssign = function(params) {
    return RestangularProvider.all('properties').customGET('available-for-invitation', params);
  };

  service.getBuildings = function(id) {
    return RestangularProvider.one('properties', id).customGET('buildings');
  };

  service.getDeleted = function (params) {
    var defer = $q.defer();
    RestangularProvider.all('properties').customGET('deleted', params).then(function (data) {
      angular.forEach(data.results, function (property) {
        property.unDelete = function () {
          return RestangularProvider.one('properties', this.id).customPATCH({}, 'undelete');
        };
      });
      defer.resolve(data);
    }, function(error){
      defer.reject(error);
    });
    return defer.promise;
  };

  service.PROGRESS_STATUS_OK = '0';
  service.PROGRESS_STATUS_WARNING = '1';
  service.PROGRESS_STATUS_DANGER = '2';

  service.PROGRESS_STATUS_OPTIONS = [
    {
      id: service.PROGRESS_STATUS_OK,
      name: 'Green'
    },
    {
      id: service.PROGRESS_STATUS_WARNING,
      name: 'Orange'
    },
    {
      id: service.PROGRESS_STATUS_DANGER,
      name: 'Red'
    }
  ];

  service.PMS_MRI = 34;
  service.PMS_REALPAGE = 3;

  service.getTasksByPriority = function(property, params) {
    return property.customGET('tasks-by-priority', params);
  };

  var canceler_pastDue = $q.defer();
  var canceler_history = $q.defer();
  var canceler_activity = $q.defer();
  var canceler_stadistics = $q.defer();
  var canceler_reload_stadistics = $q.defer();
  var canceler_export_stadistics = $q.defer();
  var canceler_reports = $q.defer();
  var canceler_status = $q.defer();

  service.getPastDue = function(params, noCancel) {
    if(!noCancel){
      canceler_pastDue.resolve();
      canceler_pastDue = $q.defer();
    }
    return RestangularProvider.all('properties').withHttpConfig({timeout: canceler_pastDue.promise}).customGET('statistics/past-due', params);
  };

  service.getHistory = function(params, noCancel) {
    if(!noCancel){
      canceler_history.resolve();
      canceler_history = $q.defer();
    }
    return RestangularProvider.all('properties').withHttpConfig({timeout: canceler_history.promise}).customGET('statistics/history', params);
  };

  service.getActivity = function(params, noCancel) {
    if(!noCancel){
      canceler_activity.resolve();
      canceler_activity = $q.defer();
    }
    return RestangularProvider.all('properties').withHttpConfig({timeout: canceler_activity.promise}).customGET('statistics/activity', params);
  };

  service.getStatistics = function(params, noCancel) {
    if(!noCancel){
      canceler_stadistics.resolve();
      canceler_stadistics = $q.defer();
    }
    return RestangularProvider.all('properties').withHttpConfig({timeout: canceler_stadistics.promise}).customGET('statistics', params);
  };

  service.reloadStatistics = function(params, noCancel) {
    if(!noCancel){
      canceler_reload_stadistics.resolve();
      canceler_reload_stadistics = $q.defer();
    }
    return RestangularProvider.all('properties').withHttpConfig({timeout: canceler_reload_stadistics.promise}).customPOST(params, 'statistics/reload');
  };

  service.exportStatistics = function (params, noCancel) {
    if(!noCancel){
      canceler_export_stadistics.resolve();
      canceler_export_stadistics = $q.defer();
    }
    return RestangularProvider.all('properties').withHttpConfig({timeout: canceler_export_stadistics.promise}).customGET('statistics/overview/export-pdf', params);
  };

  service.getReports = function(params, noCancel) {
    if(!noCancel){
      canceler_reports.resolve();
      canceler_reports = $q.defer();
    }
    return RestangularProvider.all('properties').withHttpConfig({timeout: canceler_reports.promise}).customGET('report', params);
  };

  service.getStatus = function(params, noCancel) {
    if(!noCancel){
      canceler_status.resolve();
      canceler_status = $q.defer();
    }
    var defer = $q.defer();
    RestangularProvider.all('properties').withHttpConfig({timeout: canceler_status.promise}).customGET('status', params).then(function(data) {
      angular.forEach(data.results, function (property) {
        property.getTasksByPriority = function (params) {
          return RestangularProvider.one('properties', this.id).customGET('tasks-by-priority', params);
        };
        property.getTasksByCategory = function (params) {
          return RestangularProvider.one('properties', this.id).customGET('tasks-by-category', params);
        };
        property.setNovice = function (params) {
          return RestangularProvider.one('properties', this.id).customPOST(params, 'novice');
        };
        property.moveToPortfolio = function (params) {
          return RestangularProvider.one('properties', this.id).customPOST(params, 'move-to-portfolio');
        };
        property.unDelete = function (params) {
          return RestangularProvider.one('properties', this.id).customGET('undelete', params);
        };
      });
      defer.resolve(data);
    }, function(error){
      defer.reject(error);
    });
    return defer.promise;
  };

  service.importExcel = function(params) {
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/properties/import-excel/'),
      arrayKey: '',
      data: {
        account: params.account,
        file: params.file[0].file,
        response_email_recipients: params.response_email_recipients
      }
    });
  };

  service.exportExcel = function(params) {
    return RestangularProvider.all('properties').customGET('export-properties', params);
  };

  service.bulkObject = function(account, portfolio) {
    return {
      account: account,
      portfolio: portfolio,
      fields: {}
    };
  };

  return service;
};

app.factory('PropertyService', ['BaseRestService', 'Restangular', '$q', 'ConfigThemeService', 'UploadBase', PropertyService]);
